<div routerLink="/">
    <img src="../../../../assets/icons/back-arrow.png">
    <p>Back to menu</p>
</div>